import http from '@/services/rest/rest.service';
export default {
    list(): Promise<string[]> {
        return http.get('geo/list');
    }
};
